import useI18n from '@/hooks/useI18n';
import { batchSuccessModal } from '@/utils/utils';
import { Tooltip } from 'antd';
import { uniq } from 'lodash';
import { useState } from 'react';
import memberCustom from './memberCustom';

const rowSelectionType: any = 'checkbox';
const isNeedIccId = true; // member list的查询条件
const isNeedExport = true; // member list的导出
const isQueryServType = false; // 是否需要定制化根据配置项查询服务类型
const queryServtype = '15,51'; // 默认查询member list的服务类型
const isBatchOperation = true; // 是否支持批量操作二次业务
const isNeedOTC = false; // 是否需要查询手续费
const isneedCheckMsisdn = false; // 是否需要检查
const isneedShowMemberType = true; // 是否需要检查
const isneedNewConnect = true; // 是否需要开户
const isNeedStaticIp = false; // 是否需要在成员详情里展示Static IP
const isNeedShowComments = false; // 是否需要支持comments的展示和修改
const isNeedTNC = false; // 是否需要展示TNC
const isNeedOfferDetailModal = true; // 是否需要展示offer图片和描述等信息（做产品和tm用，um不用）
const isCheckSubscriberEligibility = false; // 是否需要检验二次业务菜单初始化验证功能
const isNeedBatchSIMReplacement = true; // 是否需要展示批量SIM replcaement

const useMemberColumns = () => {
  const { formatMessage } = useI18n();
  const searchPlaceholder = undefined;
  const tableTitle = formatMessage('memberMgr.memberList');
  const customEventNew: any = (componentRef: any) => [];
  const getICCD = () => [
    {
      title: formatMessage('memberMgr.ICCID'),
      width: 200,
      dataIndex: 'iccid',
      ellipsis: true,
      render: (text: string, record: any) => (
        <Tooltip title={text}>{record.iccid}</Tooltip>
      ),
    },
  ];
  const getStateDate = () => [
    {
      title: formatMessage('memberMgr.stateDate'),
      width: 200,
      dataIndex: 'stateDate',
      // ellipsis: true,
      render: (text: string) => <Tooltip title={text}>{text}</Tooltip>,
    },
  ];

  return {
    searchPlaceholder,
    tableTitle,
    getICCD,
    getStateDate,
    customEventNew,
  };
};

const useMemberCommon = () => {
  const { formatMessage } = useI18n();
  const customDetailTabs: any = (subsId: any) => [];
  const getStaticIP: any = () => [];
  const isShowStaticIP: any = () => {};

  const customStateTitle = formatMessage('memberMgr.state');
  return {
    customDetailTabs,
    getStaticIP,
    isShowStaticIP,
    customStateTitle,
  };
};

const isBtnDisable = (el: any, selectedRows: any) => {
  const serTypes = uniq(selectedRows.map((el: any) => el.servType));

  if (el.subsEventId === 392) {
    return true;
  }
  if (!selectedRows.length && el.subsEventId !== 392) {
    return true;
  }

  // 当前event允许的服务类型进行判断
  if (serTypes.length > 1 || !el.servTypeList.includes(serTypes[0])) {
    return true;
  }

  // 判断 bundle 类型
  const isBundleMember = selectedRows?.[0]?.bundleMemFlag === 'Y';
  // bundle成员不能做sim replacement
  if (isBundleMember && el.subsEventId === 66) return true;

  // 新增：服务类型为FWA（695）服务类型支持modify offer、suspend、reactivation三种二次业务
  // 新增支持 batch activation二次业务
  // 季度开关关闭，长度大于1，不让做批量sim
  if (
    [66].includes(el.subsEventId) &&
    !el?.isBatchSIM &&
    selectedRows.length > 1
  ) {
    return true;
  }

  if (
    (selectedRows.length > 1 &&
      ([189, 32, 33].includes(el.subsEventId) ||
        (selectedRows[0].servType === 51 &&
          [329, 432].includes(el.subsEventId)))) ||
    (selectedRows[0]?.servType === 695 &&
      ![189, 28, 29, 123, 66].includes(el.subsEventId))
  ) {
    return true;
  }
  if (
    selectedRows.some(
      (item: { memberType: string }) => item.memberType === 'A',
    ) &&
    [393, 395].includes(el.subsEventId)
  ) {
    return true;
  }
  if (
    selectedRows.every(
      (item: { memberType: string }) => item.memberType === 'B',
    ) &&
    ![393, 395].includes(el.subsEventId)
  ) {
    return true;
  }

  // 不允许同时处理bm/om/bundle的业务
  if (
    selectedRows.length > 1 &&
    !selectedRows.every(
      (item: any) =>
        (item.memberType === selectedRows[0].memberType &&
          item.servType === selectedRows[0].servType &&
          item?.bundleMemFlag !== 'Y') || // 勾选多个bundle同类型的子成员不可以做二次业务
        (item.servType === 15 && el.subsEventId === 123), // bundle和非bundle支持服务类型为15的做批量激活,
    )
  ) {
    return true;
  }
  // change offer只能受理相同offer
  if (
    el.subsEventId === 329 &&
    selectedRows.length > 1 &&
    !selectedRows.every(
      (item: { subsPlan: { offerId: any } }) =>
        item.subsPlan?.offerId === selectedRows[0].subsPlan?.offerId,
    )
  ) {
    return true;
  }
  // bundle relocation 只能单笔操作
  if (
    (el.subsEventId === 33 && selectedRows[0].servType !== 51) ||
    (![33, 329, 432].includes(el.subsEventId) &&
      selectedRows[0].servType === 51)
  ) {
    return true;
  }
  // // 不允许同时处理bundle和om的业务
  // if (selectedRows.length > 1 && selectedRows.some(item => item.servType === 51)) {
  //   return true;
  // }
  return false;
};

const useGrade = () => {
  const queryGrade = () => {};
  return {
    queryGrade,
  };
};

const customEvent: any = (componentRef: any) => [];

const customStepEvent = (selectedBtnKey: any, setCurrentStep: any) => {};

const customgGetModifyOffer = (
  selectOffer: any,
  numberRef: any,
  updateFlowData: any,
  onSubmit: () => void,
  setCurrentStep: any,
  checkResult: any,
  cancelOrderVasList: any[],
  vasQuantity: any,
) => {};

const suspendActionCustom = (field: any, form: any) => {};

// 二次业务提示语
const useBatchSuccessModal = () => {
  const { formatMessage } = useI18n();
  const commonBatchSuccessModal = (wholesaleCode: any) => {
    if (wholesaleCode) {
      batchSuccessModal(
        `${formatMessage('memberMgr.operateSuccess')}${wholesaleCode}`,
      );
    } else {
      // changeMsisdn和changeSIMCard场景
      batchSuccessModal(formatMessage('memberMgr.commonoperateSuccess'));
    }
  };

  return { commonBatchSuccessModal };
};

// 定制化model
const useCustomModel = () => ({});

// 权限对应按钮code
const buttonCodeMap = new Map()
  .set(392, 'BUTTON_MEMBER_MANAGEMENT_ADD_MEMBER')
  .set(432, 'BUTTON_MEMBER_MANAGEMENT_CHANGE_BUNDLE_OFFER')
  .set(329, 'BUTTON_MEMBER_MANAGEMENT_CHANGE_OFFER')
  .set(189, 'BUTTON_MEMBER_MANAGEMENT_MODIFY_OFFER')
  .set(29, 'BUTTON_MEMBER_MANAGEMENT_REACTIVATION')
  .set(33, 'BUTTON_MEMBER_MANAGEMENT_RELOCATION')
  .set(393, 'BUTTON_MEMBER_MANAGEMENT_DELETE_MEMBER')
  .set(28, 'BUTTON_MEMBER_MANAGEMENT_VOLUNTARY_SUSPENSION')
  .set(123, 'BUTTON_MEMBER_BATCH_ACTIVATION')
  .set(66, 'BUTTON_MEMBER_MANAGEMENT_SIM_REPLACEMENT');
// change bundle offer模块Overview页面点击对应的Offer卡片detail查看详情
const useOffeDetailModal = () => {
  const [offerDetailVisible, setOfferDetailVisible] = useState(false);
  const [selectedOfferItem, setSelectedOfferItem] = useState({});

  const handleDetailOpen = (currentOfferItem: any) => {
    setOfferDetailVisible(true);
    setSelectedOfferItem(currentOfferItem);
  };

  const handleDetailClose = () => {
    setOfferDetailVisible(false);
  };

  return {
    offerDetailVisible,
    selectedOfferItem,
    handleDetailOpen,
    handleDetailClose,
  };
};

export default {
  rowSelectionType,
  isNeedIccId,
  isNeedExport,
  isQueryServType,
  isNeedOTC,
  queryServtype,
  isBatchOperation,
  isneedCheckMsisdn,
  isneedShowMemberType,
  isneedNewConnect,
  customEvent,
  isNeedStaticIp,
  suspendActionCustom,
  isBtnDisable,
  useGrade,
  useMemberCommon,
  useMemberColumns,
  useBatchSuccessModal,
  isNeedShowComments,
  useCustomModel,
  isNeedTNC,
  customStepEvent,
  customgGetModifyOffer,
  isNeedOfferDetailModal,
  isCheckSubscriberEligibility,
  buttonCodeMap,
  useOffeDetailModal,
  isNeedBatchSIMReplacement,
  ...memberCustom,
};
